import AiLabel from "@/components/ai-label";
import Category from "@/components/category";
import TeaserByLineImage from "@/components/teaser-byline-image";
import TeaserDownpull from "@/components/teaser-downpull";
import TeaserHeading from "@/components/teaser-heading";
import TeaserLinkedContent from "@/components/teaser-linked-content";
import { Content } from "@/services/content/types";
import { createImageSizes, createImageUrl } from "@/utils/image";
import classNames from "classnames";
import Image from "next/image";
import Link from "next/link";

type HorizontalProps = {
  article: Content.Article;
  showLinkedContent?: boolean;
  fullWidth?: boolean;
};

const Horizontal = ({
  article,
  showLinkedContent = true,
  fullWidth = false,
}: HorizontalProps) => {
  const hasLinkedContent = Boolean(article.fields.linkedContent?.length);
  const category = article.fields.categories?.[0];
  const image = article.fields.teaserImage || article.fields.images?.[0];
  const title = article.fields.teaserTitle || article.fields.title;
  const author = article.fields.authors?.[0];
  const showByline =
    article.fields.showByline !== undefined ? article.fields.showByline : false;
  const bylineImage =
    article.fields.hideBylineImage !== undefined
      ? article.fields.hideBylineImage
      : false;

  return (
    <div>
      <Link href={`/${article.fields.slug}`} className="relative">
        <div
          className={classNames("group flex gap-4 bg-sand-600  p-4", {
            "pb-4": hasLinkedContent,
            "w-screen md:w-auto -ml-4 md:ml-0": fullWidth,
          })}
        >
          {!bylineImage && image?.fields.file?.url && (
            <div className="relative w-[320px] h-auto">
              <div className="aspect-w-16 aspect-h-9">
                <Image
                  fill
                  src={createImageUrl(image.fields.file.url, { crop: "16:9" })}
                  alt={image.fields.alt || ""}
                  className="object-cover "
                  sizes={createImageSizes({
                    mobile: "33vw",
                    tablet: "33vw",
                    desktop: "33vw",
                  })}
                />
                <AiLabel image={image} />
              </div>
            </div>
          )}
          <div className={classNames(bylineImage ? "" : "")}>
            {category && <Category category={category} />}

            {title && (
              <TeaserHeading
                text={title}
                className="text-4xl md:text-3xl font-normal"
              />
            )}

            {bylineImage && author?.fields.image?.fields?.file?.url && (
              <TeaserByLineImage
                showbyLineImage={bylineImage}
                fileUrl={author.fields.image.fields.file.url}
                altText=""
                width={"95px"}
                height={"95px"}
              />
            )}
            <div className="">
              <TeaserDownpull
                showByline={showByline}
                authorName={author?.fields.name}
                excerpt={article.fields.excerpt}
                showbyLineImage={bylineImage}
              />
            </div>
          </div>
        </div>
      </Link>
      {showLinkedContent && (
        <div className="bg-sand-600 p-4 -mt-4">
          <TeaserLinkedContent
            linkedContent={article.fields.linkedContent}
            showLinkedContent={hasLinkedContent}
            compactMode={false}
          />
        </div>
      )}
    </div>
  );
};

export default Horizontal;
